import GeneratedLocationStore from "./generated/GeneratedLocationStore"

class LocationStore extends GeneratedLocationStore {

}

export const locationStore = new LocationStore()
